export default __webpack_public_path__ + "static/media/warning--flaggers-in-road--g1.46677e39.png";